(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["Banner"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var slides = document.querySelectorAll('.banner-slide');
    var currentSlide = 0;

    function showSlide(index) {
      slides.forEach(function(slide, i) {
        slide.style.display = i === index ? 'block' : 'none';
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    showSlide(currentSlide);
    setInterval(nextSlide, 5000); // Change slide every 5 seconds
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-section"] && !window.DesignMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');
    const tabsWrapper = document.querySelector('.tabs');
    const tabLinks = document.querySelectorAll('.tab-link');

    // Scroll tabs to the left
    leftArrow.addEventListener('click', function() {
        tabsWrapper.scrollBy({
            left: -100, // Adjust this value to control how far it scrolls
            behavior: 'smooth'
        });
    });

    // Scroll tabs to the right
    rightArrow.addEventListener('click', function() {
        tabsWrapper.scrollBy({
            left: 100, // Adjust this value to control how far it scrolls
            behavior: 'smooth'
        });
    });

  
  var tabs = document.querySelectorAll(".product-tabs .tab-link");
  var contents = document.querySelectorAll(".product-tabs .tab-content");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs and content
      tabs.forEach(function (item) {
        item.classList.remove("active");
      });
      contents.forEach(function (content) {
        content.classList.remove("active");
      });

      // Add active class to the clicked tab and corresponding content
      tab.classList.add("active");
      var activeTab = tab.getAttribute("data-tab");
      document.getElementById(activeTab).classList.add("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
      })();
